import React from "react";
import sample from "../assets/sampleimage.png"; 
const Privacypolicy = () => {
  return (
    <div>

      {/* Full-width Banner */}
      <div className="mb-4">
        <img
          src={sample}
          alt="Privacy Policy Banner"
          className="img-fluid w-100"
        />
      </div>

      {/* Main Content */}
      <div className="container mb-4">
        <h2 className="text-center mb-4">Privacy Policy</h2>

        <div className="card shadow-sm p-4">

          <p className="mb-4">
            This Privacy Policy explains how our boutique (“we”, “our”, “us”)
            collects, stores, manages, and protects your personal information
            when you access or use our website (the Platform). Some parts of the
            Platform can be browsed without registration; however, using any of
            our services means that you accept the terms of this Privacy Policy
            and India’s applicable data protection laws. If you do not agree,
            please avoid using the Platform.
          </p>

          <p className="mb-4">
            We collect personal data when you interact with our Platform, make a
            purchase, or contact us for support. This may include your name,
            contact details, address, age, payment information, and identity
            details. Sensitive information such as bank details or card
            information is collected only when required and with your consent.
            You may choose not to share specific details; however, certain
            services may become unavailable as a result.
          </p>

          <p className="mb-4">
            We use your information to process orders, improve customer
            experience, provide updates, resolve issues, personalize your
            shopping journey, and prevent fraud or unauthorized activities.
            Information may also be used for marketing or promotional
            communication—where you will always have the option to opt-out.
            Data may be shared with delivery partners, payment gateways, support
            teams, or government authorities when legally required.
          </p>

          <p className="mb-4">
            We follow reasonable security practices to safeguard your data from
            unauthorized access or misuse. While we take strong measures, online
            transmission always carries some risk. By using the Platform, you
            agree to these risks and are responsible for keeping your login
            details confidential.
          </p>

          <p className="mb-4">
            You may request correction, updates, or deletion of your personal
            information. Your account can be deleted through your profile
            settings or by contacting us directly. However, deletion may be
            delayed if you have pending orders, unresolved issues, or legal
            requirements. Some anonymized data may be retained for analytics and
            security purposes even after account deletion.
          </p>

          <p>
            By continuing to use the Platform, you consent to the collection and
            processing of your data under this Privacy Policy. You may withdraw
            consent anytime by contacting us, although this may limit access to
            certain services. We may update this Privacy Policy occasionally, and
            your continued use of the Platform means you accept the updated
            terms. Please review this page periodically for the latest version.
          </p>

        </div>
      </div>
    </div>
  );
};

export default Privacypolicy;
